module.exports = __webpack_public_path__ + "static/media/50005.97024dfd.png";